const ckconfig = {
  toolbar: {
    items: [
			'heading',
			'|',
			'bold',
			'italic',
			'bulletedList',
			'numberedList',
			'todoList',
			'blockQuote',
			'|',
			'fontFamily',
			'fontSize',
			'fontColor',
			'fontBackgroundColor',
			'highlight',
			'horizontalLine',
			'alignment',
			'indent',
			'code',
			'codeBlock',
			'specialCharacters',
			'findAndReplace',
			'link',
			'|',
			'undo',
			'redo'
		]
  },
  language: 'en',
  table: {
    contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells',
			'tableCellProperties',
			'tableProperties'
		]
  }
};

export default ckconfig;